/* eslint-disable jsx-a11y/iframe-has-title */
import {Button, Col, DatePicker, Form, Image, message, Row, Select, Typography,} from "antd";
import dayjs from "dayjs";
import moment from "moment";
import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import DiscountDetailTooltip from "../../components/DiscountDetailTooltip";
import RoomSuggestionCard from "../../components/RoomSuggestionCard";
import iconMap from "../../assets/images/iconMap.png";
import iconMic from "../../assets/images/iconMic.png";
import iconMoney from "../../assets/images/iconMoney.png";
import {onSetFormSearch, onSetPendingSuggest} from "../../features/checkRoomSlide";
import {checkDiscount, checkRoom, suggestAlternatives} from "../../services/branch";
import "../../styles/resultSearch.css";
import {minutes, moneyFormat, times} from "../../untils/constanst";
import {
    buildSuggestionCheckRoomPayload,
    buildSuggestionFormSearch,
    isSuggestionBookable,
    normalizeSuggestionResponse,
} from "../../untils/roomSuggestions";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import {
    getBookingProperties,
    trackAlternativeSelected,
    trackAlternativesShown,
    trackBranchSelected,
    trackRoomSearchFailed,
    trackRoomSearchSubmitted,
    trackRoomSearchSucceeded,
} from "../../services/analyticsEvents";

const {Option} = Select;
const ResultSearch = (props) => {
    const {branchs} = useSelector((state) => state.branchs);
    const {formSearch, pendingSuggest} = useSelector((state) => state.rooms);
    const [form] = Form.useForm();
    const [timeOrder, setTimeOrder] = useState(null);
    const [timeStart, setTimeStart] = useState(null);
    const [formArray, setFormArray] = useState([]);
    const {onSetCurrentStep, room, setRoom} = props;
    const [formList] = Form.useForm();
    const dispatch = useDispatch();
    const [isShowSuggest, setIsShowSuggest] = useState(false);
    const [timeOptions, setTimeOptions] = useState(times);
    const [loading, setLoading] = useState(false);
    const [sameTypeSlots, setSameTypeSlots] = useState([]);
    const [otherTypeSlots, setOtherTypeSlots] = useState([]);
    const discountRequestKey = useRef(0);
    useEffect(() => {
        if (formSearch && formSearch?.branch) {
            const branchCheck = branchs.find(
                (item) => item._id === formSearch?.branch,
            );
            setRoom && setRoom(branchCheck);
            formSearch?.start_time &&
            setTimeOrder(
                moment(new Date(formSearch?.start_time * 1000)).format("DD/MM/YYYY"),
            );
            formSearch?.time && setTimeStart(formSearch?.time);
            formSearch?.priceOrder && setPriceOrder(formSearch?.priceOrder);
            formSearch?.priceOrderDiscount && setPriceOrderDiscount(formSearch?.priceOrderDiscount);
            formSearch?.discountDetail && setDiscountDetail(formSearch?.discountDetail);
            if (formSearch?.room) {
                form.setFieldsValue({
                    ...formSearch,
                    start_time: dayjs(
                        moment(new Date(formSearch?.start_time * 1000)).format(
                            "DD/MM/YYYY",
                        ),
                        "DD/MM/YYYY",
                    ),
                    room: `${formSearch?.room}-${
                        branchCheck[formSearch?.room]?.day_price
                    }`,
                    time_box: `${formSearch?.time_box}`,
                });
                renderTimeStart(
                    dayjs(moment(new Date()).format("DD/MM/YYYY"), "DD/MM/YYYY"),
                    formSearch?.room,
                );
            } else {
                setTimeOrder(moment(new Date()).format("DD/MM/YYYY"));
                renderTimeStart(
                    dayjs(moment(new Date()).format("DD/MM/YYYY"), "DD/MM/YYYY"),
                    null,
                );
                form.setFieldsValue({
                    ...formSearch,
                    start_time: dayjs(
                        moment(new Date()).format("DD/MM/YYYY"),
                        "DD/MM/YYYY",
                    ),
                });
            }
        } else {
            setTimeOrder(moment(new Date()).format("DD/MM/YYYY"));
            renderTimeStart(
                dayjs(moment(new Date()).format("DD/MM/YYYY"), "DD/MM/YYYY"),
                null,
            );
            form.setFieldsValue({
                start_time: dayjs(
                    moment(new Date()).format("DD/MM/YYYY"),
                    "DD/MM/YYYY",
                ),
            });
        }
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0, {behavior: "smooth"});
    }, []);

    // Bước nhập thông tin báo hết phòng: mở luôn gợi ý cho đúng giờ khách đã chọn.
    useEffect(() => {
        if (!pendingSuggest) {
            return;
        }
        dispatch(onSetPendingSuggest(false));
        const duration = (formSearch?.end_time - formSearch?.start_time) / 60;
        if (!formSearch?.branch || !formSearch?.start_time || !(duration > 0)) {
            return;
        }
        const branchContext = branchs?.find((item) => item._id === formSearch.branch);
        showAlternatives(
            {
                branch: formSearch.branch,
                room: formSearch.room,
                start_time: formSearch.start_time,
                time_box: duration,
            },
            branchContext,
            'Phòng bạn chọn vừa được khách khác đặt trước.',
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onCheckDiscount = async (valueForm) => {
        const requestKey = discountRequestKey.current + 1;
        discountRequestKey.current = requestKey;
        const data = await checkDiscount(valueForm);
        if (data && data?.code === 2000) {
            let fee = data?.data ? data?.data?.fee : 0;
            let discount = data?.data ? data?.data?.discount : 0
            const nextDiscountDetail = data?.data || null;
            const nextPriceOrderDiscount = fee - discount;

            if (discountRequestKey.current === requestKey) {
                setPriceOrderDiscount(nextPriceOrderDiscount);
                setPriceOrder(fee);
                setDiscountDetail(nextDiscountDetail);
            }

            return {
                priceOrder: fee,
                priceOrderDiscount: nextPriceOrderDiscount,
                discountDetail: nextDiscountDetail,
            };
        }

        if (discountRequestKey.current === requestKey) {
            setPriceOrderDiscount(0);
            setPriceOrder(0);
            setDiscountDetail(null);
        }

        return {
            priceOrder: 0,
            priceOrderDiscount: 0,
            discountDetail: null,
        };
    }

    // valueForm: {branch, room, start_time (giây), time_box (phút)}.
    const showAlternatives = async (valueForm, branchContext, reason = 'Đã hết phòng theo yêu cầu.') => {
        // Call suggest alternatives API to get room suggestions
        try {
            const suggestData = await suggestAlternatives({
                start_time: valueForm?.start_time,
                time_duration: valueForm?.time_box,
                room_type: valueForm?.room,
                branch_id: valueForm?.branch
            });

            const normalizedSuggestions = normalizeSuggestionResponse(suggestData?.data, branchs);
            if (suggestData && suggestData?.code === 2000 && normalizedSuggestions.totalCount > 0) {
                trackAlternativesShown({
                    ...getBookingProperties(valueForm, branchContext, branchContext),
                    device_type: "desktop",
                    suggestion_count: normalizedSuggestions.totalCount,
                });
                renderFormArray(normalizedSuggestions);
                setIsShowSuggest(true);
                
                // Show a simple notification that suggestions are available
                Swal.fire({
                    icon: 'info',
                    title: 'Tìm thấy phòng thay thế',
                    text: `${reason} Chúng tôi đã tìm thấy ${normalizedSuggestions.totalCount} gợi ý phòng thay thế bên dưới.`,
                    confirmButtonText: 'Xem gợi ý',
                    timer: 3000
                });
            } else {
                // No suggestions available
                Swal.fire({
                    icon: 'warning',
                    title: 'Thông báo',
                    text: `${reason} Hiện không có gợi ý thay thế. Hãy chọn lại thời gian hoặc chi nhánh khác!`,
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error fetching suggestions:', error);
            // Fallback to original message
            Swal.fire({
                icon: 'warning',
                title: 'Thông báo',
                text: `${reason} Hãy chọn lại thời gian hoặc phòng khác!`,
                confirmButtonText: 'OK'
            });
        }
    };

    const onSubmit = async (values) => {
        setLoading(true);
        if (checkTimeValue()) {
            return;
        }

        if (checkTimeOut()) {
            Swal.fire({
                icon: 'warning',
                title: 'Thông báo',
                text: 'Đã quá giờ đóng cửa. Hãy chọn lại thời gian!',
                confirmButtonText: 'OK'
            });
            setLoading(false);
            return;
        }

        const start_time = values?.start_time ? new Date(values?.start_time?.$d) : new Date();

        const hour = timeStart?.slice(0, 2);
        const minute = timeStart?.slice(3, 5);

        if (Number(hour) < 6) {
            start_time.setHours(Number(hour) + 24);
            start_time.setMinutes(Number(minute));
        } else {
            start_time.setHours(Number(hour));
            start_time.setMinutes(Number(minute));
        }

        let room = "small";
        if (values?.room) {
            if (values?.room?.includes("medium")) {
                room = "medium";
            } else if (values?.room?.includes("large")) {
                room = "large";
            }
        }
        const valueForm = {
            ...values,
            room: room,
            time_box: Number(
                values?.time_box === "0" ? values?.time_box_input : values?.time_box,
            ),
            start_time: Math.floor(start_time.getTime() / 1000),
        };
        delete valueForm["time"];
        const branchContext = branchs?.find((item) => item._id === valueForm.branch);
        const discountResult = await onCheckDiscount(valueForm);
        trackRoomSearchSubmitted({
            ...getBookingProperties(valueForm, branchContext, branchContext),
            device_type: "desktop",
        });
        const data = await checkRoom(valueForm);
        if (data && data?.code === 2000) {
            trackRoomSearchSucceeded({
                ...getBookingProperties(
                    {
                        ...valueForm,
                        priceOrder: discountResult.priceOrder,
                        priceOrderDiscount: discountResult.priceOrderDiscount,
                    },
                    branchContext,
                    branchContext,
                ),
                device_type: "desktop",
            });
            onSetCurrentStep(1);
            dispatch(
                onSetFormSearch({
                    ...valueForm,
                    time_box: values?.time_box,
                    priceOrder: discountResult.priceOrder,
                    priceOrderDiscount: discountResult.priceOrderDiscount,
                    discountDetail: discountResult.discountDetail,
                    time: timeStart,
                    end_time:
                        Math.floor(start_time.getTime() / 1000) +
                        Number(
                            values?.time_box === "0"
                                ? values?.time_box_input
                                : values?.time_box,
                        ) *
                        60,
                }),
            );
            message.success(
                "Đã đặt lịch phòng thành công, hãy nhập thông tin để tiếp tục.",
            );
        }

        if (data && data?.code === 2101) {
            trackRoomSearchFailed({
                ...getBookingProperties(valueForm, branchContext, branchContext),
                device_type: "desktop",
                failure_code: data?.code,
                failure_reason: "no_room",
            });
            await showAlternatives(valueForm, branchContext);
        } else if (data && data?.code !== 2000) {
            trackRoomSearchFailed({
                ...getBookingProperties(valueForm, branchContext, branchContext),
                device_type: "desktop",
                failure_code: data?.code,
                failure_reason: "unexpected_response",
            });
        } else if (!data) {
            trackRoomSearchFailed({
                ...getBookingProperties(valueForm, branchContext, branchContext),
                device_type: "desktop",
                failure_reason: "no_response",
            });
        }
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    };

    const disabledDate = (current) => {
        return current <= dayjs().add(-1, "day");
    };

    const onSetTimeStart = (value) => {
        setTimeStart(value);
        onChangeTimeOrder(value);
        // checkTimeOut();
    };

    const onSetTimeOrder = (value, string) => {
        if (value) {
            setTimeOrder(string);
        }
        renderTimeStart(value, room);
        onChangeTimeOrder(value);
        const values = form.getFieldsValue();
        form.setFieldsValue({...values, time: null});
    };

    const onSelectRoom = (value) => {
        if (value) {
            const roomSelect = branchs.find((item) => item._id === value);
            if (roomSelect) {
                setRoom && setRoom(roomSelect);
                trackBranchSelected({
                    ...getBookingProperties(formSearch, roomSelect, roomSelect),
                    device_type: "desktop",
                });
            }
            if (!timeOrder) {
                renderTimeStart(
                    dayjs(moment(new Date()).format("DD/MM/YYYY"), "DD/MM/YYYY"),
                    roomSelect,
                );
            } else {
                renderTimeStart(dayjs(timeOrder, "DD/MM/YYYY"), roomSelect);
            }
        } else {
            setRoom && setRoom(null);
        }

        form.setFieldValue("room", null);
        form.setFieldValue("time", null);
    };

    const checkTimeValue = () => {
        let dateStrArr = timeOrder.split("/");
        const day = dateStrArr[0] // new Date(timeOrder).getDay();
        const month = dateStrArr[1]  //new Date(timeOrder).getMonth();
        const year = dateStrArr[2]  //new Date(timeOrder).getFullYear();
        const dayCurrent = new Date().getDate();
        const monthCurrent = new Date().getMonth();
        const yearCurrent = new Date().getFullYear();
        if (day === dayCurrent && month === monthCurrent && year === yearCurrent) {
            const hour = timeStart?.slice(0, 2);
            const minute = timeStart?.slice(3, 5);
            const currentHour = new Date().getHours();
            const currentMinute = new Date().getMinutes();

            if (Number(hour) === currentHour && Number(minute) < currentMinute) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    const checkTimeOut = () => {
        const valueForm = form.getFieldsValue();
        const day = valueForm?.start_time?.$D;
        const month = new Date(valueForm?.start_time?.$d).getMonth();
        const year = new Date(valueForm?.start_time?.$d).getFullYear();
        const dayCurrent = new Date().getDate();
        const monthCurrent = new Date().getMonth();
        const yearCurrent = new Date().getFullYear();

        if (day === dayCurrent && month === monthCurrent && year === yearCurrent) {
            const hour = valueForm?.time?.slice(0, 2);
            const minute = valueForm?.time?.slice(3, 5);
            const hourStart = Number(hour) + Number(minute) / 60;
            const timeOrder = Number(valueForm.time_box);
            let endTime = hourStart + timeOrder / 60;

            // Parse close_time from room prop
            let closeTime = 24; // default close at midnight
            if (room && room.close_time) {
                const [closeHourStr, closeMinuteStr] = room.close_time.split(":");
                const closeHour = Number(closeHourStr);
                const closeMinute = Number(closeMinuteStr);
                if (closeHour === 0 && closeMinute === 0) {
                    closeTime = 24; // midnight
                } else if (closeHour > 0 && closeHour < 12) {
                    // open past midnight, e.g. 03:00 means 27.0
                    if (0 <= hourStart && hourStart <= 3) {
                        closeTime = closeHour + closeMinute / 60;
                    } else {
                        closeTime = 24 + closeHour + closeMinute / 60;
                    }
                } else {
                    // closes before midnight
                    closeTime = closeHour + closeMinute / 60;
                }
            }

            // If endTime passes midnight, wrap to next day
            if (endTime >= 24) {
                endTime = 24 + (endTime - 24);
            }

            return endTime > closeTime;
        } else {
            return false;
        }
    };

    const [priceOrder, setPriceOrder] = useState(0);
    const [priceOrderDiscount, setPriceOrderDiscount] = useState(0);
    const [discountDetail, setDiscountDetail] = useState(null);

    const onChangeTimeOrder = (value) => {
        // checkTimeOut();
        const valueForm = form.getFieldsValue();

        if (
            valueForm?.time &&
            valueForm.time_box &&
            valueForm?.room &&
            valueForm.branch
        ) {

            const hour = valueForm?.time?.slice(0, 2);
            const minute = valueForm?.time?.slice(3, 5);
            let room = "small";
            if (valueForm?.room) {
                if (valueForm?.room?.includes("medium")) {
                    room = "medium";
                } else if (valueForm?.room?.includes("large")) {
                    room = "large";
                }
            }

            const start_time = valueForm?.start_time ? new Date(valueForm?.start_time?.$d) : new Date();
            if (Number(hour) < 6) {
                start_time.setHours(Number(hour) + 24);
                start_time.setMinutes(Number(minute));
            } else {
                start_time.setHours(Number(hour));
                start_time.setMinutes(Number(minute));
            }

            const checkDiscountForm = {
                branch: valueForm?.branch,
                room: room,
                time_box: Number(
                    valueForm?.time_box === "0" ? valueForm?.time_box_input : valueForm?.time_box,
                ),
                start_time: Math.floor(start_time.getTime() / 1000),
            }
            onCheckDiscount(checkDiscountForm);

        } else {
            setPriceOrder(0);
            setPriceOrderDiscount(0);
            setDiscountDetail(null);
        }
    };

    const renderTimeStart = (date, roomSelect) => {
        const day = date?.$D;
        const month = new Date(date?.$d).getMonth();
        const year = new Date(date?.$d).getFullYear();
        const dayCurrent = new Date().getDate();
        const monthCurrent = new Date().getMonth();
        const yearCurrent = new Date().getFullYear();

        let optionTimes = times;
        const timeClose = roomSelect?.close_time;
        if (timeClose) {
            const timeCloseConfigLst = timeClose?.split(":");
            const endHourConfig = Number(timeCloseConfigLst[0]);


            if (endHourConfig === 0 || endHourConfig > 6) {
                optionTimes = optionTimes.filter((item) => item.key < 24);
            } else {
                optionTimes = optionTimes.filter((item) => (item.key > 6 && item.key < 24) || (item.key - 24 < endHourConfig - 0.25));
            }
        }

        if (day === dayCurrent && month === monthCurrent && year === yearCurrent) {
            const hourOrder = new Date().getHours();
            const minuteOrder = new Date().getMinutes();
            const selectOrder = hourOrder + minuteOrder / 60;
            const timeConfig = roomSelect?.open_time;
            if (timeConfig) {
                const timeConfigLst = timeConfig?.split(":");
                const startHourConfig = Number(timeConfigLst[0]);
                const startMinuteConfig = Number(timeConfigLst[1]);
                const timeHour = startHourConfig + startMinuteConfig / 60;
                setTimeOptions(
                    optionTimes.filter(
                        (item) => item.key > selectOrder && item.key >= timeHour,
                    ),
                );
            } else {
                setTimeOptions(optionTimes.filter((item) => item.key > selectOrder));
            }
        } else {
            if (roomSelect?.open_time) {
                const timeConfig = roomSelect.open_time;
                const timeConfigLst = timeConfig?.split(":");
                const startHourConfig = Number(timeConfigLst[0]);
                const startMinuteConfig = Number(timeConfigLst[1]);
                const timeHour = startHourConfig + startMinuteConfig / 60;
                setTimeOptions(optionTimes.filter((item) => item.key >= timeHour));
            } else {
                setTimeOptions(optionTimes);
            }
        }
    };

    const renderFormArray = (normalizedSuggestions) => {
        const sameTypeFormatted = normalizedSuggestions?.sameTypeSlots || [];
        const otherTypeFormatted = normalizedSuggestions?.otherTypeSlots || [];
        const combinedArray = normalizedSuggestions?.allSlots || [];
        setSameTypeSlots(sameTypeFormatted);
        setOtherTypeSlots(otherTypeFormatted);
        setFormArray(combinedArray);
        formList.setFieldValue("users", combinedArray);
    };

    const [loadingOrder, setLoadingOrder] = useState(false);
    const [loadingKey, setLoadingKey] = useState(null);

    const onCheckRoomOrder = async (roomCheck, index) => {
        setLoadingKey(index);
        setLoadingOrder(true);
        if (!isSuggestionBookable(roomCheck)) {
            message.error("Gợi ý phòng chưa đủ thông tin đặt phòng. Vui lòng chọn gợi ý khác.", 3);
            setLoadingOrder(false);
            return;
        }
        const valueForm = buildSuggestionCheckRoomPayload(roomCheck);
        trackAlternativeSelected({
            ...getBookingProperties(
                {
                    ...valueForm,
                    priceOrder: roomCheck?.priceOrder,
                    priceOrderDiscount: roomCheck?.priceOrderDiscount,
                },
                roomCheck,
                roomCheck,
            ),
            device_type: "desktop",
            suggestion_group: roomCheck?.suggestion_group,
            suggestion_index: roomCheck?.suggestion_index ?? index,
        });
        const data = await checkRoom(valueForm);
        if (data && data?.code === 2000) {
            setTimeout(() => {
                onSetCurrentStep(1);
                dispatch(
                    onSetFormSearch(buildSuggestionFormSearch(roomCheck, valueForm)),
                );
                message.success(
                    "Đã đặt lịch phòng thành công, hãy nhập thông tin để tiếp tục.",
                );
            }, 1000);
        }

        if (data && data?.code === 2101) {
            trackRoomSearchFailed({
                ...getBookingProperties(valueForm, roomCheck, roomCheck),
                device_type: "desktop",
                failure_code: data?.code,
                failure_reason: "selected_suggestion_unavailable",
            });
            Swal.fire({
                icon: 'warning',
                title: 'Thông báo',
                text: 'Đã hết phòng theo yêu cầu. Hãy chọn lại thời gian hoặc phòng khác!',
                confirmButtonText: 'OK'
            });
        } else if (data && data?.code !== 2000) {
            trackRoomSearchFailed({
                ...getBookingProperties(valueForm, roomCheck, roomCheck),
                device_type: "desktop",
                failure_code: data?.code,
                failure_reason: "unexpected_response",
            });
        } else if (!data) {
            trackRoomSearchFailed({
                ...getBookingProperties(valueForm, roomCheck, roomCheck),
                device_type: "desktop",
                failure_reason: "no_response",
            });
        }

        setTimeout(() => {
            setLoadingOrder(false);
        }, 1000);
    };

    const checkTime = (index) => {
        const {users} = formList.getFieldsValue();
        if (users?.length > 0) {
            const value = users[index];
            if (value?.time && value?.time_box) {
                const hour = value?.time?.slice(0, 2);
                const minute = value?.time?.slice(3, 5);
                const hourStart = Number(hour) + Number(minute) / 60;
                const timeOrder = value?.time_box;

                if (hourStart + Number(timeOrder) / 60 >= 24) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    };

    return (
        <div>
            <Form form={form} onFinish={onSubmit}>
                <Row gutter={[24]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={room ? 12 : 24}>
                        <div
                            style={{
                                border: "1px solid #f0f0f0",
                                padding: "20px",
                                borderRadius: "12px",
                            }}
                        >
                            <Row gutter={[24, 24]} className="mb-2">
                                <Col sx={24} sm={24} md={24} lg={24} xl={room ? 24 : 12}>
                                    <Typography.Title
                                        level={5}
                                        className="mt-0 mb-1 text-info ms-0"
                                    >
                                        Chọn cơ sở
                                    </Typography.Title>
                                    <Form.Item
                                        rules={[
                                            {
                                                required: true,
                                                message: "Bạn phải chọn cơ sở",
                                            },
                                        ]}
                                        name="branch"
                                        initialValue={null}
                                        className="m-0"
                                    >
                                        <Select
                                            showSearch
                                            className="select-list"
                                            size="large"
                                            allowClear={true}
                                            defaultValue={null}
                                            placeholder="Chọn cơ sở"
                                            optionLabelProp="label"
                                            onChange={onSelectRoom}
                                            filterOption={(input, option) =>
                                                option?.label?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {branchs?.map((item) => (
                                                <Option
                                                    key={item._id}
                                                    value={item?._id}
                                                    label={`${item.name} - ${item.address}`}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <Image src={iconMap} preview={false}/>
                                                        <div className="ps-1">
                                                            <p className="m-0">
                                                                {item.name}
                                                                {item?.phone ? `: ${item?.phone}` : ""}
                                                            </p>
                                                            <p className="m-0">{item.address}</p>
                                                        </div>
                                                    </div>
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col sx={24} sm={24} md={24} lg={24} xl={room ? 24 : 12}>
                                    <Typography.Title
                                        level={5}
                                        className="mt-0 mb-1 text-info ms-0"
                                    >
                                        Chọn phòng
                                    </Typography.Title>
                                    <Form.Item
                                        rules={[
                                            {
                                                required: true,
                                                message: "Bạn phải chọn phòng",
                                            },
                                        ]}
                                        name="room"
                                        initialValue={null}
                                        className="m-0"
                                    >
                                        <Select
                                            disabled={!room}
                                            optionLabelProp="label"
                                            className="select-list"
                                            size="large"
                                            allowClear={true}
                                            defaultValue={null}
                                            placeholder="Chọn phòng"
                                            onChange={onChangeTimeOrder}
                                        >
                                            {room?.small && room?.small?.count > 0 && (
                                                <Option
                                                    key={`small-${room?.small?.day_price}`}
                                                    value={`small-${room?.small?.day_price}`}
                                                    label={`S Box (từ ${room?.small?.capacity} người)`}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <Image src={iconMic} preview={false}/>
                                                        <div className="ps-1">
                                                            <p className="m-0">
                                                                S Box (từ {room?.small?.capacity} người)
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Option>
                                            )}

                                            {room?.medium && room?.medium?.count > 0 && (
                                                <Option
                                                    key={`medium-${room?.medium?.day_price}`}
                                                    value={`medium-${room?.medium?.day_price}`}
                                                    label={`M Box (từ ${room?.medium?.capacity} người)`}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <Image src={iconMic} preview={false}/>
                                                        <div className="ps-1">
                                                            <p className="m-0">
                                                                M Box (từ {room?.medium?.capacity}{" "}
                                                                người)
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Option>
                                            )}

                                            {room?.large && room?.large?.count > 0 && (
                                                <Option
                                                    key={`large-${room?.large?.day_price}`}
                                                    value={`large-${room?.large?.day_price}`}
                                                    label={`L Box (trên ${room?.large?.capacity} người)`}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <Image src={iconMic} preview={false}/>
                                                        <div className="ps-1">
                                                            <p className="m-0">
                                                                L Box(trên {room?.large?.capacity}{" "}
                                                                người)
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Option>
                                            )}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[24]} className="mb-2">
                                <Col sx={24} sm={24} md={12} lg={12} xl={12}>
                                    <Typography.Title
                                        level={5}
                                        className="mt-0 mb-1 text-info ms-0"
                                    >
                                        Chọn ngày
                                    </Typography.Title>
                                    <Form.Item
                                        name="start_time"
                                        className="m-0"
                                        initialValue={null}
                                    >
                                        <DatePicker
                                            size="large"
                                            disabledDate={disabledDate}
                                            className="select-list h-38"
                                            defaultOpenValue={dayjs(
                                                moment(new Date(), "DD/MM/YYYY"),
                                                "DD/MM/YYYY",
                                            )}
                                            onChange={onSetTimeOrder}
                                            style={{width: "100%"}}
                                            placeholder="Chọn ngày"
                                            format="DD/MM/YYYY"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col sx={24} sm={24} md={12} lg={12} xl={12}>
                                    <Typography.Title
                                        level={5}
                                        className="mt-0 mb-1 text-info ms-0"
                                    >
                                        Chọn giờ
                                    </Typography.Title>
                                    <Row className="d-flex" gutter={[12, 12]}>
                                        <Col span={12}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Bạn phải chọn giờ đặt phòng",
                                                    },
                                                ]}
                                                name="time"
                                                className="m-0"
                                            >
                                                <Select
                                                    disabled={!timeOrder}
                                                    className="select-list"
                                                    size="large"
                                                    allowClear={true}
                                                    defaultValue={null}
                                                    placeholder="Giờ bắt đầu"
                                                    options={timeOptions}
                                                    onChange={onSetTimeStart}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                name="time_box"
                                                className="m-0"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Bạn phải chọn thời gian",
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    disabled={!timeStart}
                                                    className="select-list"
                                                    size="large"
                                                    allowClear={false}
                                                    defaultValue={null}
                                                    placeholder="Thời gian"
                                                    options={minutes}
                                                    onChange={onChangeTimeOrder}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    {/*{checkTimeOut() && (*/}
                                    {/*	<span className="text-red">*/}
                                    {/*		Bạn đã đặt phòng quá thời gian đóng cửa của quán là 24h*/}
                                    {/*		ngày hiện tại. Vui lòng thử lại!*/}
                                    {/*	</span>*/}
                                    {/*)}*/}
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    {room && <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                        <div
                            style={{
                                border: "1px solid #f0f0f0",
                                borderRadius: "12px",
                            }}
                        >
                            <Image src={room?.price_image} preview={false} width={"100%"}/>

                            {room?.google_map && (
                                <div
                                    className="d-flex align-items-center"
                                    style={{
                                        padding: "20px",
                                    }}
                                >
                                    <Image src={iconMap} preview={false}/>
                                    <div className="">
                                        <p
                                            className="m-0"
                                            style={{fontSize: "16px", fontWeight: "500"}}
                                        >
                                            {room?.address}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Col>}
                </Row>
                <div className="box-wrapper-order mt-2">
                    <div>
                        <p className="text-order-price">Số tiền cần thanh toán
                            <DiscountDetailTooltip
                                discountDetail={discountDetail}
                                tooltipId="result-search-discount-detail"
                            />
                        </p>
                        <h5 className="text-order-number">
                            <span
                                className={"origin-price" + (priceOrderDiscount > 0 && priceOrderDiscount !== priceOrder ? ' not-same' : ' same')}>{moneyFormat(priceOrder)} VND</span>
                            {priceOrderDiscount > 0 && priceOrderDiscount !== priceOrder && (
                                <span className="discount-price">{moneyFormat(priceOrderDiscount)} VND</span>)}
                        </h5>
                    </div>
                    <Form.Item
                        className="m-0
					"
                    >
                        <Button loading={loading} htmlType="submit" className="btn-search">
                            Đặt phòng
                        </Button>
                    </Form.Item>
                </div>
            </Form>
            {isShowSuggest && (
                <div>
                
                    <Typography.Title
                        style={{
                            marginBottom: "24px",
                            fontSize: 24,
                            borderTop: "1px dashed #D0D5DD",
                            paddingTop: "24px",
                        }}
                        level={4}
                    >
                        Đề xuất kết quả
                    </Typography.Title>
                    <p
                        style={{
                            fontSize: 14,
                            fontWeight: 400,
                            marginBottom: 24,
                            marginTop: 8,
                        }}
                    >
                        Chúng tôi cũng có những phòng trống tại những địa điểm sau. Nếu bạn
                        quan tâm, xin vui lòng chọn phòng nhé!
                    </p>

                    {/* Same Type Suggestions Section */}
                    {sameTypeSlots && sameTypeSlots.length > 0 && (
                        <div style={{ marginBottom: '32px' }}>
                            <Typography.Title
                                style={{
                                    marginBottom: "16px",
                                    fontSize: 18,
                                    color: "#7932ED",
                                    display: "flex",
                                    alignItems: "center"
                                }}
                                level={5}
                            >
                                📍 Cùng loại phòng 
                                <span style={{ 
                                    backgroundColor: "#7932ED", 
                                    color: "white", 
                                    borderRadius: "12px", 
                                    padding: "2px 8px", 
                                    fontSize: "12px", 
                                    marginLeft: "8px" 
                                }}>
                                    {sameTypeSlots.length}
                                </span>
                            </Typography.Title>
                            <Form
                                form={formList}
                                name="same_type_form"
                                autoComplete="off"
                            >
                                <Row gutter={[24]}>
                                    {sameTypeSlots.map((item, index) => (
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12} key={`same-${index}`}>
                                            <RoomSuggestionCard
                                                item={item}
                                                itemKey={`same-${index}`}
                                                loadingKey={loadingKey}
                                                loadingOrder={loadingOrder}
                                                onBook={onCheckRoomOrder}
                                                groupLabel="Cùng loại phòng"
                                                accentColor="#7932ED"
                                            />
                                        </Col>
                                    ))}
                                </Row>
                            </Form>
                        </div>
                    )}

                    {/* Other Type Suggestions Section */}
                    {otherTypeSlots && otherTypeSlots.length > 0 && (
                        <div>
                            <Typography.Title
                                style={{
                                    marginBottom: "16px",
                                    fontSize: 18,
                                    color: "#1890ff",
                                    display: "flex",
                                    alignItems: "center"
                                }}
                                level={5}
                            >
                                🔄 Loại phòng khác 
                                <span style={{ 
                                    backgroundColor: "#1890ff", 
                                    color: "white", 
                                    borderRadius: "12px", 
                                    padding: "2px 8px", 
                                    fontSize: "12px", 
                                    marginLeft: "8px" 
                                }}>
                                    {otherTypeSlots.length}
                                </span>
                            </Typography.Title>
                            <Form
                                form={formList}
                                name="other_type_form"
                                autoComplete="off"
                            >
                                <Row gutter={[24]}>
                                    {otherTypeSlots.map((item, index) => (
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12} key={`other-${index}`}>
                                            <RoomSuggestionCard
                                                item={item}
                                                itemKey={`other-${index}`}
                                                loadingKey={loadingKey}
                                                loadingOrder={loadingOrder}
                                                onBook={onCheckRoomOrder}
                                                groupLabel="Loại phòng khác"
                                                accentColor="#1890ff"
                                            />
                                        </Col>
                                    ))}
                                </Row>
                            </Form>
                        </div>
                    )}

                    {/* Fallback: Show combined list if no separate data */}
                    {(!sameTypeSlots || sameTypeSlots.length === 0) && (!otherTypeSlots || otherTypeSlots.length === 0) && formArray && formArray?.length > 0 && (
                        <Form
                            form={formList}
                            name="dynamic_form_nest_item"
                            autoComplete="off"
                        >
                            <Form.List name="users">
                                {(fields, {add, remove}) => (
                                    <Row gutter={[24]}>
                                        {formArray.map((item, index) => (
                                            <Col xs={24} sm={24} md={12} lg={12} xl={12} key={index}>
                                                <div className="box-result">
                                                    <div className="box-info">
                                                        <Typography.Title
                                                            style={{marginBottom: 8, marginTop: 0}}
                                                            level={4}
                                                        >
                                                            {item?.name}
                                                        </Typography.Title>
                                                        <div
                                                            className="d-flex fs-18 fw-400"
                                                            style={{marginBottom: 8}}
                                                        >
                                                            <Image preview={false} src={iconMap}/>
                                                            <Link
                                                                to={item?.google_map}
                                                                target="_blank"
                                                                className="text-link-mobile"
                                                            >
                                                                <Typography.Text className="hover-address text-info">
                                                                    {item.address}
                                                                </Typography.Text>
                                                            </Link>
                                                            <div className="mapouter">
                                                                <div className="gmap_canvas">
                                                                    <iframe
                                                                        className="gmap_iframe"
                                                                        frameborder="0"
                                                                        marginheight="0"
                                                                        marginwidth="0"
                                                                        src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=Keang Nam &amp;t=p&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                                                                    ></iframe>
                                                                    <a href="https://capcuttemplate.org/">
                                                                        Capcut Templates
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="d-flex align-items-center fs-18 fw-400"
                                                            style={{marginBottom: 8}}
                                                        >
                                                            <Image preview={false} src={iconMic}/>
                                                            <Typography.Text className="text-info">
                                                                Box (từ {item?.capacity} người)
                                                            </Typography.Text>
                                                        </div>
                                                        <div
                                                            className="d-flex align-items-center fs-18 fw-400"
                                                            style={{marginBottom: 8}}
                                                        >
                                                            <Image preview={false} src={iconMoney}/>
                                                            <Typography.Text className="text-info">
                                                                Trước 18h: {moneyFormat(item?.day_price)}
                                                                VND/h
                                                            </Typography.Text>
                                                        </div>
                                                        <div
                                                            className="d-flex align-items-center fs-18 fw-400"
                                                            style={{marginBottom: 12}}
                                                        >
                                                            <Image preview={false} src={iconMoney}/>
                                                            <Typography.Text className="text-info">
                                                                Sau 18h: {moneyFormat(item?.night_price)}
                                                                VND/h
                                                            </Typography.Text>
                                                        </div>

                                                        <div
                                                            style={{
                                                                borderBottom: "1px #D8D8D8 dashed",
                                                                paddingBottom: "18px",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    fontSize: 18,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <Typography.Title
                                                                    level={5}
                                                                    className="mt-0 mb-1 text-info ms-0"
                                                                >
                                                                    Khung giờ:
                                                                </Typography.Title>
                                                                <span className="ms-1 mb-1">
																	Từ{" "}
                                                                    {moment(item?.start_time * 1000).format(
                                                                        "HH:mm",
                                                                    )}{" "}
                                                                    đến{" "}
                                                                    {moment(item?.end_time * 1000).format(
                                                                        "HH:mm",
                                                                    )}
																</span>
                                                            </div>
                                                            {checkTime(index) && (
                                                                <span className="text-red">
																	Bạn đã đặt phòng quá thời gian đóng cửa của
																	quán là 24h ngày hiện tại. Vui lòng thử lại!
																</span>
                                                            )}
                                                        </div>

                                                        <div
                                                            style={{
                                                                marginTop: "18px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            <div>
                                                                <p className="text-order-price">
                                                                    Tổng tiền thanh toán
                                                                </p>
                                                                <h5 className="text-order-number">
                                                                    {moneyFormat(item.priceOrder)} VND
                                                                </h5>
                                                            </div>
                                                            <Form.Item className="m-0">
                                                                <Button
                                                                    disabled={!item.isBookable}
                                                                    loading={
                                                                        loadingOrder &&
                                                                        item.priceOrder &&
                                                                        loadingKey === index
                                                                    }
                                                                    onClick={() => onCheckRoomOrder(item, index)}
                                                                    style={{
                                                                        fontSize: "18px",
                                                                        fontWeight: "500",
                                                                        color: "#7932ED",
                                                                        border: "1px solid #7932ED",
                                                                        padding: "12px 24px",
                                                                        borderRadius: "8px",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignContent: "center",
                                                                        alignItems: "center",
                                                                        height: "50px",
                                                                    }}
                                                                >
                                                                    Đặt phòng
                                                                </Button>
                                                            </Form.Item>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                )}
                            </Form.List>
                        </Form>
                    )}
                </div>
            )}
        </div>
    );
};

ResultSearch.propTypes = {
    room: PropTypes.object,
    setRoom: PropTypes.func
};

export default ResultSearch;
